export function Heart() {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
    >
      <path
        d="M10.1 15.55L10 15.65L9.89 15.55C5.14 11.24 2 8.39 2 5.5C2 3.5 3.5 2 5.5 2C7.04 2 8.54 3 9.07 4.36H10.93C11.46 3 12.96 2 14.5 2C16.5 2 18 3.5 18 5.5C18 8.39 14.86 11.24 10.1 15.55ZM14.5 0C12.76 0 11.09 0.81 10 2.08C8.91 0.81 7.24 0 5.5 0C2.42 0 0 2.41 0 5.5C0 9.27 3.4 12.36 8.55 17.03L10 18.35L11.45 17.03C16.6 12.36 20 9.27 20 5.5C20 2.41 17.58 0 14.5 0Z"
        fill="#FF3366"
      />
    </svg>
  );
}

export function FullHeart() {
  return (
    <svg
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18.35L8.55 17.03C3.4 12.36 0 9.27 0 5.5C0 2.41 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.08C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.41 20 5.5C20 9.27 16.6 12.36 11.45 17.03L10 18.35Z"
        fill="#FF3366"
      />
    </svg>
  );
}

export function Write() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
    >
      <path
        d="M13.5903 3.50845L15.811 1.28403C15.9926 1.10217 16.2389 1 16.4957 1C16.7525 1 16.9988 1.10217 17.1804 1.28403L18.7164 2.82259C18.898 3.00451 19 3.25122 19 3.50845C19 3.76568 18.898 4.01238 18.7164 4.1943L16.4957 6.41872M13.5903 3.50845L8.06314 9.04476C7.8815 9.22664 7.77943 9.47335 7.77937 9.73061V11.2692C7.77937 11.5265 7.88141 11.7732 8.06304 11.9551C8.24466 12.1371 8.491 12.2393 8.74786 12.2393H10.2839C10.5407 12.2392 10.787 12.137 10.9686 11.955L16.4957 6.41872M13.5903 3.50845L16.4957 6.41872M3.90545 12.2393H2.93696C2.42325 12.2393 1.93057 12.4437 1.56732 12.8075C1.20407 13.1714 1 13.6649 1 14.1795C1 14.694 1.20407 15.1875 1.56732 15.5514C1.93057 15.9152 2.42325 16.1196 2.93696 16.1196H16.4957C17.0094 16.1196 17.5021 16.324 17.8654 16.6879C18.2286 17.0518 18.4327 17.5452 18.4327 18.0598C18.4327 18.5744 18.2286 19.0679 17.8654 19.4317C17.5021 19.7956 17.0094 20 16.4957 20H12.6218"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Delete() {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="shrink-0"
    >
      <path
        d="M17.86 3.81818H14.44V2.67273C14.4375 1.96465 14.1564 1.28629 13.6581 0.785603C13.1598 0.284913 12.4847 0.0025154 11.78 0H7.22C6.51529 0.0025154 5.84017 0.284913 5.34186 0.785603C4.84356 1.28629 4.5625 1.96465 4.56 2.67273V3.81818H1.14C0.837653 3.81818 0.54769 3.93886 0.333898 4.15368C0.120107 4.36849 0 4.65984 0 4.96364C0 5.26743 0.120107 5.55878 0.333898 5.77359C0.54769 5.98841 0.837653 6.10909 1.14 6.10909H1.52V19.0909C1.5225 19.5965 1.72348 20.0806 2.07926 20.4381C2.43504 20.7955 2.91686 20.9975 3.42 21H15.58C16.0831 20.9975 16.565 20.7955 16.9207 20.4381C17.2765 20.0806 17.4775 19.5965 17.48 19.0909V6.10909H17.86C18.1623 6.10909 18.4523 5.98841 18.6661 5.77359C18.8799 5.55878 19 5.26743 19 4.96364C19 4.65984 18.8799 4.36849 18.6661 4.15368C18.4523 3.93886 18.1623 3.81818 17.86 3.81818ZM6.84 2.67273C6.84 2.57146 6.88004 2.47435 6.9513 2.40274C7.02256 2.33114 7.11922 2.29091 7.22 2.29091H11.78C11.8808 2.29091 11.9774 2.33114 12.0487 2.40274C12.12 2.47435 12.16 2.57146 12.16 2.67273V3.81818H6.84V2.67273ZM15.2 18.7091H3.8V6.10909H15.2V18.7091ZM8.36 9.16364V15.2727C8.36 15.5765 8.23989 15.8679 8.0261 16.0827C7.81231 16.2975 7.52235 16.4182 7.22 16.4182C6.91765 16.4182 6.62769 16.2975 6.4139 16.0827C6.20011 15.8679 6.08 15.5765 6.08 15.2727V9.16364C6.08 8.85984 6.20011 8.56849 6.4139 8.35368C6.62769 8.13886 6.91765 8.01818 7.22 8.01818C7.52235 8.01818 7.81231 8.13886 8.0261 8.35368C8.23989 8.56849 8.36 8.85984 8.36 9.16364ZM12.92 9.16364V15.2727C12.92 15.5765 12.7999 15.8679 12.5861 16.0827C12.3723 16.2975 12.0823 16.4182 11.78 16.4182C11.4777 16.4182 11.1877 16.2975 10.9739 16.0827C10.7601 15.8679 10.64 15.5765 10.64 15.2727V9.16364C10.64 8.85984 10.7601 8.56849 10.9739 8.35368C11.1877 8.13886 11.4777 8.01818 11.78 8.01818C12.0823 8.01818 12.3723 8.13886 12.5861 8.35368C12.7999 8.56849 12.92 8.85984 12.92 9.16364Z"
        fill="#FF3366"
      />
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.35 30.45L19.95 22.05C19.2 22.65 18.3375 23.125 17.3625 23.475C16.3875 23.825 15.35 24 14.25 24C11.525 24 9.219 23.056 7.332 21.168C5.445 19.28 4.501 16.974 4.5 14.25C4.5 11.525 5.444 9.219 7.332 7.332C9.22 5.445 11.526 4.501 14.25 4.5C16.975 4.5 19.281 5.444 21.168 7.332C23.055 9.22 23.999 11.526 24 14.25C24 15.35 23.825 16.3875 23.475 17.3625C23.125 18.3375 22.65 19.2 22.05 19.95L30.4875 28.3875C30.7625 28.6625 30.9 29 30.9 29.4C30.9 29.8 30.75 30.15 30.45 30.45C30.175 30.725 29.825 30.8625 29.4 30.8625C28.975 30.8625 28.625 30.725 28.35 30.45ZM14.25 21C16.125 21 17.719 20.3435 19.032 19.0305C20.345 17.7175 21.001 16.124 21 14.25C21 12.375 20.3435 10.781 19.0305 9.468C17.7175 8.155 16.124 7.499 14.25 7.5C12.375 7.5 10.781 8.1565 9.468 9.4695C8.155 10.7825 7.499 12.376 7.5 14.25C7.5 16.125 8.1565 17.719 9.4695 19.032C10.7825 20.345 12.376 21.001 14.25 21Z"
        fill="#ff3366"
      />
    </svg>
  );
}

export function TreeDot() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 36 36"
      fill="none"
    >
      <path
        d="M18 21.6C17.0452 21.6 16.1295 21.2207 15.4544 20.5456C14.7793 19.8704 14.4 18.9548 14.4 18C14.4 17.0452 14.7793 16.1295 15.4544 15.4544C16.1295 14.7793 17.0452 14.4 18 14.4C18.9548 14.4 19.8704 14.7793 20.5456 15.4544C21.2207 16.1295 21.6 17.0452 21.6 18C21.6 18.9548 21.2207 19.8704 20.5456 20.5456C19.8704 21.2207 18.9548 21.6 18 21.6ZM18 10.8C17.0452 10.8 16.1295 10.4207 15.4544 9.74556C14.7793 9.07043 14.4 8.15475 14.4 7.19998C14.4 6.2452 14.7793 5.32952 15.4544 4.65439C16.1295 3.97926 17.0452 3.59998 18 3.59998C18.9548 3.59998 19.8704 3.97926 20.5456 4.65439C21.2207 5.32952 21.6 6.2452 21.6 7.19998C21.6 8.15475 21.2207 9.07043 20.5456 9.74556C19.8704 10.4207 18.9548 10.8 18 10.8ZM18 32.4C17.0452 32.4 16.1295 32.0207 15.4544 31.3456C14.7793 30.6704 14.4 29.7548 14.4 28.8C14.4 27.8452 14.7793 26.9295 15.4544 26.2544C16.1295 25.5793 17.0452 25.2 18 25.2C18.9548 25.2 19.8704 25.5793 20.5456 26.2544C21.2207 26.9295 21.6 27.8452 21.6 28.8C21.6 29.7548 21.2207 30.6704 20.5456 31.3456C19.8704 32.0207 18.9548 32.4 18 32.4Z"
        fill="white"
      />
    </svg>
  );
}

export function TreeDotDark() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99995 10.7998C8.52256 10.7998 8.06472 10.6102 7.72716 10.2726C7.38959 9.93503 7.19995 9.47719 7.19995 8.9998C7.19995 8.52241 7.38959 8.06458 7.72716 7.72701C8.06472 7.38945 8.52256 7.1998 8.99995 7.1998C9.47734 7.1998 9.93518 7.38945 10.2727 7.72701C10.6103 8.06458 10.8 8.52241 10.8 8.9998C10.8 9.47719 10.6103 9.93503 10.2727 10.2726C9.93518 10.6102 9.47734 10.7998 8.99995 10.7998ZM8.99995 5.3998C8.52256 5.3998 8.06472 5.21016 7.72716 4.8726C7.38959 4.53503 7.19995 4.07719 7.19995 3.5998C7.19995 3.12241 7.38959 2.66458 7.72716 2.32701C8.06472 1.98945 8.52256 1.7998 8.99995 1.7998C9.47734 1.7998 9.93518 1.98945 10.2727 2.32701C10.6103 2.66458 10.8 3.12241 10.8 3.5998C10.8 4.07719 10.6103 4.53503 10.2727 4.8726C9.93518 5.21016 9.47734 5.3998 8.99995 5.3998ZM8.99995 16.1998C8.52256 16.1998 8.06472 16.0102 7.72716 15.6726C7.38959 15.335 7.19995 14.8772 7.19995 14.3998C7.19995 13.9224 7.38959 13.4646 7.72716 13.127C8.06472 12.7894 8.52256 12.5998 8.99995 12.5998C9.47734 12.5998 9.93518 12.7894 10.2727 13.127C10.6103 13.4646 10.8 13.9224 10.8 14.3998C10.8 14.8772 10.6103 15.335 10.2727 15.6726C9.93518 16.0102 9.47734 16.1998 8.99995 16.1998Z"
        fill="#5A5959"
      />
    </svg>
  );
}

export function Prev() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FF3366"
        d="m13.3 17.3l-4.6-4.6q-.15-.15-.212-.325T8.425 12q0-.2.063-.375T8.7 11.3l4.6-4.6q.275-.275.7-.275t.7.275q.275.275.275.7t-.275.7L10.8 12l3.9 3.9q.275.275.275.7t-.275.7q-.275.275-.7.275t-.7-.275Z"
      />
    </svg>
  );
}

export function Next() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FF3366"
        d="M8.7 17.3q-.275-.275-.275-.7t.275-.7l3.9-3.9l-3.9-3.9q-.275-.275-.275-.7t.275-.7q.275-.275.7-.275t.7.275l4.6 4.6q.15.15.213.325t.062.375q0 .2-.063.375t-.212.325l-4.6 4.6q-.275.275-.7.275t-.7-.275Z"
      />
    </svg>
  );
}

export function Add() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 45 45"
      fill="none"
    >
      <path
        d="M33.75 24.3713H24.375V33.7463C24.375 34.2436 24.1775 34.7205 23.8258 35.0722C23.4742 35.4238 22.9973 35.6213 22.5 35.6213C22.0027 35.6213 21.5258 35.4238 21.1742 35.0722C20.8225 34.7205 20.625 34.2436 20.625 33.7463V24.3713H11.25C10.7527 24.3713 10.2758 24.1738 9.92418 23.8222C9.57254 23.4705 9.375 22.9936 9.375 22.4963C9.375 21.9991 9.57254 21.5221 9.92418 21.1705C10.2758 20.8189 10.7527 20.6213 11.25 20.6213H20.625V11.2463C20.625 10.7491 20.8225 10.2721 21.1742 9.92051C21.5258 9.56888 22.0027 9.37134 22.5 9.37134C22.9973 9.37134 23.4742 9.56888 23.8258 9.92051C24.1775 10.2721 24.375 10.7491 24.375 11.2463V20.6213H33.75C34.2473 20.6213 34.7242 20.8189 35.0758 21.1705C35.4275 21.5221 35.625 21.9991 35.625 22.4963C35.625 22.9936 35.4275 23.4705 35.0758 23.8222C34.7242 24.1738 34.2473 24.3713 33.75 24.3713Z"
        fill="white"
      />
    </svg>
  );
}
export function Retweet() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7 9H16V11H7V9ZM16 5H4V7H16V5ZM20 2V20L16 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 0.9 0.9 0 2 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2ZM18 2H2V14H16.83L18 15.17V2Z"
        fill="#4A4A4A"
      />
    </svg>
  );
}

export function LeftPlay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M4 5V19M20 5V19L8 12L20 5Z"
        stroke="#FF3366"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Play() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M7 4V20L20 12L7 4Z"
        stroke="#FF3366"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RightPlay() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 5V19M4 5V19L16 12L4 5Z"
        stroke="#FF3366"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NoneImg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="90"
      height="83"
      viewBox="0 0 90 83"
      fill="none"
    >
      <path
        d="M80 9.22217H10C8.67392 9.22217 7.40215 9.70798 6.46447 10.5727C5.52678 11.4375 5 12.6103 5 13.8333V69.1666C5 70.3896 5.52678 71.5624 6.46447 72.4272C7.40215 73.2919 8.67392 73.7777 10 73.7777H80C81.3261 73.7777 82.5979 73.2919 83.5355 72.4272C84.4732 71.5624 85 70.3896 85 69.1666V13.8333C85 12.6103 84.4732 11.4375 83.5355 10.5727C82.5979 9.70798 81.3261 9.22217 80 9.22217ZM10 69.1666V13.8333H80V69.1666H10Z"
        fill="#FF3366"
      />
      <path
        d="M22.3 32.2777C23.7833 32.2777 25.2334 31.872 26.4668 31.112C27.7001 30.352 28.6614 29.2718 29.2291 28.0079C29.7967 26.744 29.9453 25.3533 29.6559 24.0116C29.3665 22.6699 28.6522 21.4375 27.6033 20.4702C26.5544 19.5029 25.218 18.8441 23.7632 18.5772C22.3083 18.3104 20.8003 18.4473 19.4299 18.9708C18.0594 19.4943 16.8881 20.3809 16.064 21.5183C15.2399 22.6558 14.8 23.993 14.8 25.361C14.8 27.1954 15.5902 28.9547 16.9967 30.2518C18.4032 31.549 20.3109 32.2777 22.3 32.2777ZM22.3 21.6721C23.0922 21.6676 23.868 21.88 24.529 22.2826C25.1901 22.6851 25.7067 23.2596 26.0133 23.9333C26.3199 24.6069 26.4027 25.3493 26.2512 26.0664C26.0996 26.7835 25.7207 27.443 25.1623 27.9612C24.6039 28.4794 23.8912 28.833 23.1146 28.9772C22.338 29.1215 21.5324 29.0498 20.8001 28.7712C20.0677 28.4927 19.4415 28.0199 19.0009 27.4128C18.5602 26.8057 18.325 26.0916 18.325 25.361C18.3315 24.3906 18.7524 23.4617 19.4965 22.7756C20.2405 22.0894 21.2478 21.7012 22.3 21.6952V21.6721Z"
        fill="#FF3366"
      />
      <path
        d="M56.95 35.4366L43.45 47.8866L33.45 38.6643C32.9816 38.2349 32.348 37.9939 31.6875 37.9939C31.027 37.9939 30.3934 38.2349 29.925 38.6643L14.8 52.7974V59.3221L31.775 43.6674L40 51.1374L30.625 59.7832H37.5L58.625 40.3013L75 55.3335V48.8318L60.475 35.4366C60.0066 35.0071 59.373 34.7661 58.7125 34.7661C58.052 34.7661 57.4184 35.0071 56.95 35.4366Z"
        fill="#FF3366"
      />
    </svg>
  );
}

export function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M8.11998 9.29007L12 13.1701L15.88 9.29007C15.9726 9.19749 16.0825 9.12405 16.2034 9.07394C16.3244 9.02384 16.454 8.99805 16.585 8.99805C16.7159 8.99805 16.8456 9.02384 16.9665 9.07394C17.0875 9.12405 17.1974 9.19749 17.29 9.29007C17.3826 9.38265 17.456 9.49256 17.5061 9.61352C17.5562 9.73449 17.582 9.86414 17.582 9.99507C17.582 10.126 17.5562 10.2556 17.5061 10.3766C17.456 10.4976 17.3826 10.6075 17.29 10.7001L12.7 15.2901C12.6075 15.3828 12.4976 15.4563 12.3766 15.5065C12.2556 15.5567 12.1259 15.5825 11.995 15.5825C11.864 15.5825 11.7343 15.5567 11.6134 15.5065C11.4924 15.4563 11.3825 15.3828 11.29 15.2901L6.69998 10.7001C6.60727 10.6076 6.53372 10.4977 6.48354 10.3767C6.43336 10.2557 6.40753 10.126 6.40753 9.99507C6.40753 9.8641 6.43336 9.73442 6.48354 9.61344C6.53372 9.49247 6.60727 9.38258 6.69998 9.29007C7.08998 8.91007 7.72998 8.90007 8.11998 9.29007Z"
        fill="white"
      />
    </svg>
  );
}

export function LogOut() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20 12H10.5M18 15L21 12L18 9M13 7V6C13 5.46957 12.7893 4.96086 12.4142 4.58579C12.0391 4.21071 11.5304 4 11 4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V18C4 18.5304 4.21071 19.0391 4.58579 19.4142C4.96086 19.7893 5.46957 20 6 20H11C11.5304 20 12.0391 19.7893 12.4142 19.4142C12.7893 19.0391 13 18.5304 13 18V17"
        stroke="#FF3366"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Calender() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17 2H15V1C15 0.734784 14.8946 0.48043 14.7071 0.292893C14.5196 0.105357 14.2652 0 14 0C13.7348 0 13.4804 0.105357 13.2929 0.292893C13.1054 0.48043 13 0.734784 13 1V2H7V1C7 0.734784 6.89464 0.48043 6.70711 0.292893C6.51957 0.105357 6.26522 0 6 0C5.73478 0 5.48043 0.105357 5.29289 0.292893C5.10536 0.48043 5 0.734784 5 1V2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.316071 3.44129 0 4.20435 0 5V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7956 2 17 2ZM18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V10H18V17ZM18 8H2V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H5V5C5 5.26522 5.10536 5.51957 5.29289 5.70711C5.48043 5.89464 5.73478 6 6 6C6.26522 6 6.51957 5.89464 6.70711 5.70711C6.89464 5.51957 7 5.26522 7 5V4H13V5C13 5.26522 13.1054 5.51957 13.2929 5.70711C13.4804 5.89464 13.7348 6 14 6C14.2652 6 14.5196 5.89464 14.7071 5.70711C14.8946 5.51957 15 5.26522 15 5V4H17C17.2652 4 17.5196 4.10536 17.7071 4.29289C17.8946 4.48043 18 4.73478 18 5V8Z"
        fill="#FF3366"
      />
    </svg>
  );
}

export function UserProfileImg() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.3333 16.7503C31.3333 18.9605 30.4553 21.0801 28.8925 22.6429C27.3297 24.2057 25.2101 25.0837 23 25.0837C20.7898 25.0837 18.6702 24.2057 17.1074 22.6429C15.5446 21.0801 14.6666 18.9605 14.6666 16.7503C14.6666 14.5402 15.5446 12.4206 17.1074 10.8578C18.6702 9.29497 20.7898 8.41699 23 8.41699C25.2101 8.41699 27.3297 9.29497 28.8925 10.8578C30.4553 12.4206 31.3333 14.5402 31.3333 16.7503ZM27.1666 16.7503C27.1666 17.8554 26.7276 18.9152 25.9462 19.6966C25.1648 20.478 24.105 20.917 23 20.917C21.8949 20.917 20.8351 20.478 20.0537 19.6966C19.2723 18.9152 18.8333 17.8554 18.8333 16.7503C18.8333 15.6453 19.2723 14.5854 20.0537 13.804C20.8351 13.0226 21.8949 12.5837 23 12.5837C24.105 12.5837 25.1648 13.0226 25.9462 13.804C26.7276 14.5854 27.1666 15.6453 27.1666 16.7503Z"
        fill="#FF3366"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 0.0834961C10.3437 0.0834961 0.083313 10.3439 0.083313 23.0002C0.083313 35.6564 10.3437 45.9168 23 45.9168C35.6562 45.9168 45.9166 35.6564 45.9166 23.0002C45.9166 10.3439 35.6562 0.0834961 23 0.0834961ZM4.24998 23.0002C4.24998 27.3543 5.7354 31.3627 8.22498 34.546C9.97338 32.25 12.2289 30.3892 14.8155 29.1091C17.402 27.8291 20.2494 27.1643 23.1354 27.1668C25.984 27.1641 28.7956 27.8117 31.3561 29.0601C33.9165 30.3086 36.1582 32.125 37.9104 34.371C39.7155 32.0035 40.9309 29.2402 41.456 26.3097C41.9811 23.3793 41.8009 20.3659 40.9302 17.5189C40.0595 14.6719 38.5234 12.0732 36.4489 9.93774C34.3745 7.8023 31.8213 6.19154 29.0008 5.23872C26.1802 4.28591 23.1733 4.01844 20.2289 4.45844C17.2844 4.89844 14.487 6.03327 12.0682 7.76902C9.64945 9.50478 7.67875 11.7916 6.31921 14.4402C4.95966 17.0887 4.25036 20.023 4.24998 23.0002ZM23 41.7502C18.6957 41.7566 14.5214 40.2759 11.1833 37.5585C12.5269 35.635 14.3153 34.0646 16.3962 32.9808C18.4772 31.8969 20.7891 31.3318 23.1354 31.3335C25.4524 31.3316 27.7364 31.8826 29.7977 32.9406C31.8591 33.9986 33.6382 35.5332 34.9875 37.4168C31.6235 40.2225 27.3804 41.7563 23 41.7502Z"
        fill="#FF3366"
      />
    </svg>
  );
}

export function Stop() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M9 4H7C6.46957 4 5.96086 4.21071 5.58579 4.58579C5.21071 4.96086 5 5.46957 5 6V18C5 18.5304 5.21071 19.0391 5.58579 19.4142C5.96086 19.7893 6.46957 20 7 20H9C9.53043 20 10.0391 19.7893 10.4142 19.4142C10.7893 19.0391 11 18.5304 11 18V6C11 5.46957 10.7893 4.96086 10.4142 4.58579C10.0391 4.21071 9.53043 4 9 4ZM17 4H15C14.4696 4 13.9609 4.21071 13.5858 4.58579C13.2107 4.96086 13 5.46957 13 6V18C13 18.5304 13.2107 19.0391 13.5858 19.4142C13.9609 19.7893 14.4696 20 15 20H17C17.5304 20 18.0391 19.7893 18.4142 19.4142C18.7893 19.0391 19 18.5304 19 18V6C19 5.46957 18.7893 4.96086 18.4142 4.58579C18.0391 4.21071 17.5304 4 17 4Z"
        fill="#FF3366"
      />
    </svg>
  );
}

export function Speaker() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
    >
      <path
        d="M11.3492 0.0952678C11.1915 0.0181793 11.0154 -0.013098 10.8408 0.0049952C10.6662 0.0230884 10.5002 0.0898255 10.3617 0.197612L4.99062 4.37496H1.5625C1.1481 4.37496 0.750671 4.53958 0.457646 4.8326C0.16462 5.12563 0 5.52305 0 5.93746V10.9375C0 11.3519 0.16462 11.7493 0.457646 12.0423C0.750671 12.3353 1.1481 12.5 1.5625 12.5H4.99062L10.3617 16.6773C10.5002 16.7851 10.6662 16.8518 10.8408 16.8699C11.0154 16.888 11.1916 16.8568 11.3493 16.7797C11.507 16.7026 11.6398 16.5828 11.7328 16.4339C11.8257 16.285 11.875 16.113 11.875 15.9375V0.937455C11.875 0.761932 11.8257 0.589937 11.7327 0.441047C11.6398 0.292157 11.5069 0.172352 11.3492 0.0952678ZM1.875 6.24996H4.375V10.625H1.875V6.24996ZM10 14.0203L6.25 11.1039V5.77105L10 2.85464V14.0203ZM15.625 8.43746C15.6251 9.2749 15.3195 10.0836 14.7656 10.7117C14.6842 10.804 14.5853 10.8794 14.4747 10.9335C14.3641 10.9877 14.2439 11.0195 14.1211 11.0272C13.9982 11.0349 13.875 11.0183 13.7585 10.9783C13.642 10.9384 13.5345 10.8759 13.4422 10.7945C13.3499 10.713 13.2745 10.6142 13.2203 10.5036C13.1662 10.393 13.1344 10.2728 13.1267 10.1499C13.119 10.027 13.1356 9.90382 13.1755 9.78734C13.2154 9.67086 13.2779 9.56338 13.3594 9.47105C13.6105 9.18576 13.7491 8.81871 13.7491 8.43863C13.7491 8.05855 13.6105 7.6915 13.3594 7.40621C13.2033 7.21861 13.1265 6.97753 13.1453 6.73421C13.1642 6.49088 13.2771 6.2645 13.4602 6.10315C13.6434 5.94181 13.8822 5.85824 14.1259 5.87018C14.3697 5.88213 14.5992 5.98867 14.7656 6.16714C15.319 6.79399 15.6246 7.60128 15.625 8.43746ZM18.75 8.43746C18.751 10.0519 18.1559 11.6098 17.0789 12.8125C16.9131 12.9978 16.6805 13.1097 16.4323 13.1235C16.184 13.1374 15.9404 13.052 15.7551 12.8863C15.5697 12.7205 15.4578 12.4879 15.444 12.2397C15.4301 11.9914 15.5155 11.7478 15.6813 11.5625C16.4499 10.703 16.8749 9.59047 16.8749 8.43746C16.8749 7.28444 16.4499 6.17187 15.6813 5.31246C15.5958 5.2213 15.5295 5.11399 15.4861 4.99683C15.4427 4.87967 15.4232 4.75502 15.4287 4.63021C15.4342 4.5054 15.4646 4.38294 15.518 4.27003C15.5715 4.15713 15.647 4.05605 15.7401 3.97274C15.8332 3.88943 15.942 3.82557 16.0602 3.78491C16.1783 3.74425 16.3034 3.72761 16.428 3.73596C16.5527 3.74432 16.6744 3.77751 16.786 3.83358C16.8977 3.88965 16.997 3.96746 17.0781 4.06246C18.1554 5.26501 18.7507 6.82295 18.75 8.43746Z"
        fill="#FF3366"
      />
    </svg>
  );
}
